export const appendUtmParamsToUrl = (baseUrl: string, utmParams: URLSearchParams): string => {
  if (!utmParams.toString()) {
    return baseUrl;
  }

  const url = new URL(baseUrl);

  utmParams.forEach((value, key) => {
    url.searchParams.set(key, value);
  });

  return url.toString();
};
